{
  "result": {
    "why": "Why?",
    "why_label": "Why? Opens why the ball did that."
  },
  "slot": {
    "one_in": "1 in {n, number}",
    "in_ten": "{n, number} in 10"
  },
  "reason": {
    "swing": {
      "good": "{unit, select, points {Holed. You hole {inTen} from there.} other {A good swing: {oneIn} is better.}}",
      "poor": "{unit, select, points {You hole {inTen} from there.} other {{detail, select, mishit {A mishit: it finished {distance} from your aim.} big_miss {A wild swing: it finished {distance} from your aim.} double_cross {A double-cross: it curved the other way, {distance} off line.} other {{size, select, under_one {The swing: close to your average. {oneIn} is further off.} other {The swing: {distance} off your average. {oneIn} is further off.}}}}}}"
    },
    "speed": {
      "short": "Your swing speed took {distance} off it.",
      "long": "Your swing speed added {distance}."
    },
    "strength": {
      "long": "Your strength saved {distance} from the deep rough."
    },
    "build": {
      "short": "Your build took {distance} off it.",
      "long": "Your build added {distance}."
    },
    "style": {
      "helped": "Your playing style: pattern {percent}% tighter.",
      "hurt": "Your playing style: pattern {percent}% wider."
    },
    "tiredness": {
      "short": "Tired legs took {distance} off it.",
      "hurt": "{unit, select, points {Tired legs made a miss like this {points, plural, one {# point} other {# points}} more likely.} other {Tired legs: pattern {percent}% wider.}}"
    },
    "hydration": {
      "short": "Being short of water took {distance} off it.",
      "hurt": "Being short of water: pattern {percent}% wider."
    },
    "health": {
      "short": "Carrying an injury took {distance} off it.",
      "hurt": "{detail, select, swing_rebuild {A swing change in progress: pattern {percent}% wider.} other {Carrying an injury: pattern {percent}% wider.}}"
    },
    "confidence": {
      "helped": "Confidence was high: pattern {percent}% tighter.",
      "hurt": "Confidence was low: pattern {percent}% wider."
    },
    "momentum": {
      "helped": "On a good run: pattern {percent}% tighter.",
      "hurt": "After a hard few holes: pattern {percent}% wider."
    },
    "form": {
      "helped": "In good form: pattern {percent}% tighter.",
      "hurt": "Out of form: pattern {percent}% wider."
    },
    "course_knowledge": {
      "helped": "Knowing this course: pattern {percent}% tighter.",
      "hurt": "New to this course: pattern {percent}% wider."
    },
    "rust": {
      "short": "A lay-off took {distance} off it.",
      "hurt": "Back after a lay-off: pattern {percent}% wider."
    },
    "warm_up": {
      "helped": "Your warm-up: pattern {percent}% tighter.",
      "hurt": "Not warmed up: pattern {percent}% wider."
    },
    "adaptive": {
      "helped": "Your set-up from this lie: pattern {percent}% tighter.",
      "hurt": "Your set-up from this lie: pattern {percent}% wider."
    },
    "growth": {
      "hurt": "A growth spurt: pattern {percent}% wider."
    },
    "nerves": {
      "hurt": "{unit, select, points {{detail, select, putt {Nerves: {points, plural, one {# point} other {# points}} off your chance to hole it.} mishit {Nerves: {points, plural, one {# point} other {# points}} more chance of a mishit.} big_miss {Nerves: {points, plural, one {# point} other {# points}} more chance of a big miss.} other {{points, plural, one {# point} other {# points}} less chance than usual.}}} other {Nerves: {percent}% wider.}}"
    },
    "routine_groove": {
      "hurt": "Routine not settled: the nerves bit {percent}% more."
    },
    "club_quality": {
      "short": "This club: {distance} shorter.",
      "long": "This club: {distance} longer.",
      "helped": "This club: pattern {percent}% tighter.",
      "hurt": "This club: pattern {percent}% wider."
    },
    "fit": {
      "short": "{detail, select, ball {The fit of your ball took {distance} off it.} other {The fit of this club took {distance} off it.}}",
      "helped": "A fitted club: pattern {percent}% tighter.",
      "hurt": "The fit of this club: pattern {percent}% wider."
    },
    "groove_wear": {
      "long": "Worn grooves: it ran on {distance} further.",
      "hurt": "Worn grooves: pattern {percent}% wider."
    },
    "grip_wear": {
      "hurt": "{unit, select, points {Worn grips made a miss like this {points, plural, one {# point} other {# points}} more likely.} other {Worn grips: pattern {percent}% wider.}}"
    },
    "ball": {
      "short": "Your ball: {distance} shorter.",
      "long": "Your ball: {distance} longer."
    },
    "ball_wear": {
      "short": "A scuffed ball took {distance} off it.",
      "hurt": "A scuffed ball: pattern {percent}% wider."
    },
    "shoes": {
      "hurt": "Worn shoes on wet ground: pattern {percent}% wider."
    },
    "glove": {
      "helped": "A dry glove: pattern {percent}% tighter.",
      "hurt": "A wet glove: pattern {percent}% wider."
    },
    "waterproofs": {
      "short": "Waterproofs on: {distance} shorter.",
      "helped": "Waterproofs kept you dry: pattern {percent}% tighter.",
      "hurt": "Waterproofs on in the dry: pattern {percent}% wider."
    },
    "thermals": {
      "long": "Thermals kept out the cold: {distance} longer.",
      "helped": "Thermals kept out the cold: pattern {percent}% tighter."
    },
    "lie": {
      "short": "{kind, select, not_allowed_for {Short by {distance}: the ball sat down more than you allowed for.} other {{detail, select, rough {The rough took {distance} off it.} deep_rough {The deep rough took {distance} off it.} first_cut {The first cut took {distance} off it.} fairway_bunker {The sand took {distance} off it.} bare {The bare lie took {distance} off it.} other {The lie took {distance} off it.}}}}",
      "long": "{kind, select, not_allowed_for {Long by {distance}: the ball sat up more than you allowed for.} other {{detail, select, flyer {A flyer from the rough: {distance} long.} other {The lie added {distance}.}}}}",
      "hurt": "{unit, select, points {From that lie a miss like this was {points, plural, one {# point} other {# points}} more likely.} other {From that lie: pattern {percent}% wider.}}"
    },
    "mud": {
      "short": "Mud on the ball took {distance} off it.",
      "left": "Mud on the ball moved it {distance} left.",
      "right": "Mud on the ball moved it {distance} right.",
      "hurt": "Mud on the ball: pattern {percent}% wider."
    },
    "grain": {
      "short": "Into the grain: it stopped {distance} short.",
      "long": "Down the grain: it ran {distance} past.",
      "helped": "{unit, select, points {The grain: {points, plural, one {# point} other {# points}} more chance to hole it.} other {The grain: pattern {percent}% tighter.}}",
      "hurt": "{unit, select, points {The grain: {points, plural, one {# point} other {# points}} off your chance to hole it.} other {The grain: pattern {percent}% wider.}}"
    },
    "lip": {
      "short": "The bunker's lip kept you to a shorter club: {distance} short."
    },
    "short_side": {
      "short": "Little green to work with: it stopped {distance} short.",
      "long": "Little green to work with: it ran {distance} past."
    },
    "slope": {
      "short": "Short by {distance}: the stance took more off it than you allowed.",
      "long": "Long by {distance}: the stance took less off it than you allowed.",
      "left": "{than, select, more {Left by {distance}: the lie curved it more than you allowed for.} other {Left by {distance}: the lie curved it less than you allowed for.}}",
      "right": "{than, select, more {Right by {distance}: the lie curved it more than you allowed for.} other {Right by {distance}: the lie curved it less than you allowed for.}}",
      "hurt": "{unit, select, points {From that stance a miss like this was {points, plural, one {# point} other {# points}} more likely.} other {From that stance: pattern {percent}% wider.}}"
    },
    "elevation": {
      "short": "Short by {distance}: the shot was uphill.",
      "long": "Long by {distance}: the shot was downhill."
    },
    "plays_local": {
      "short": "Short by {distance}: it played longer than you allowed for.",
      "long": "Long by {distance}: it played shorter than you allowed for."
    },
    "wind": {
      "short": "{than, select, more {Short by {distance}: the wind was stronger than you allowed for.} other {Short by {distance}: the wind helped less than you allowed for.}}",
      "long": "{than, select, more {Long by {distance}: the wind helped more than you allowed for.} other {Long by {distance}: the wind was lighter than you allowed for.}}",
      "left": "{than, select, more {Left by {distance}: the wind moved it more than you allowed for.} other {Left by {distance}: the wind moved it less than you allowed for.}}",
      "right": "{than, select, more {Right by {distance}: the wind moved it more than you allowed for.} other {Right by {distance}: the wind moved it less than you allowed for.}}",
      "hurt": "In this wind: pattern {percent}% wider."
    },
    "gust": {
      "short": "A gust took {distance} off it.",
      "long": "A gust took it {distance} further.",
      "left": "A gust moved it {distance} left.",
      "right": "A gust moved it {distance} right."
    },
    "rain": {
      "short": "The rain took {distance} off it.",
      "hurt": "{unit, select, points {In the rain a miss like this was {points, plural, one {# point} other {# points}} more likely.} other {In the rain: pattern {percent}% wider.}}"
    },
    "wet_ground": {
      "hurt": "Wet ground: pattern {percent}% wider."
    },
    "heat": {
      "hurt": "Sweaty hands in the heat: pattern {percent}% wider."
    },
    "temperature": {
      "short": "Cold air took {distance} off it.",
      "long": "Warm air added {distance}."
    },
    "altitude": {
      "short": "Thick air at this height took {distance} off it.",
      "long": "Thin air at this height added {distance}."
    },
    "firmness": {
      "short": "Soft ground: it stopped {distance} sooner.",
      "long": "Firm ground: it ran on {distance} further."
    },
    "green_speed": {
      "short": "A slow green: it stopped {distance} short.",
      "long": "A quick green: it ran {distance} past.",
      "hurt": "{unit, select, points {The pace of the green: {points, plural, one {# point} other {# points}} off your chance to hole it.} other {The pace of the green: pattern {percent}% wider.}}"
    },
    "green_slope": {
      "short": "Up the tilt of the green: it stopped {distance} short.",
      "long": "Down the tilt of the green: it ran {distance} past.",
      "left": "The tilt of the green took it {distance} left.",
      "right": "The tilt of the green took it {distance} right.",
      "hurt": "{unit, select, points {The tilt of the green: {points, plural, one {# point} other {# points}} off your chance to hole it.} other {The tilt of the green: pattern {percent}% wider.}}"
    },
    "green_today": {
      "short": "The green today: it stopped {distance} short.",
      "long": "The green today: it ran {distance} past.",
      "helped": "The green today: {points, plural, one {# point} other {# points}} more chance to hole it.",
      "hurt": "The green today: {points, plural, one {# point} other {# points}} off your chance to hole it."
    },
    "trees": {
      "short": "It caught a tree and finished {distance} short.",
      "long": "It came off a tree and finished {distance} long.",
      "left": "It caught a tree and finished {distance} left.",
      "right": "It caught a tree and finished {distance} right."
    },
    "light": {
      "short": "A glow ball: {distance} shorter.",
      "hurt": "In this light a lost ball was {points, plural, one {# point} other {# points}} more likely."
    },
    "club": {
      "short": "Short by {distance}: this club does not reach that target.",
      "long": "Long by {distance}: this club goes past that target."
    },
    "shape": {
      "left": "{optionName}: it leaned {distance} left.",
      "right": "{optionName}: it leaned {distance} right.",
      "helped": "{optionName}: pattern {percent}% tighter.",
      "hurt": "{unit, select, points {{optionName}: a miss like this was {points, plural, one {# point} other {# points}} more likely.} other {{optionName}: pattern {percent}% wider.}}"
    },
    "height": {
      "short": "{detail, select, low {Low flight took {distance} off it.} high {High flight: the wind took {distance} off it.} other {Short by {distance}.}}",
      "long": "{detail, select, low {Low flight: it ran on {distance} further.} high {High flight added {distance}.} other {Long by {distance}.}}",
      "left": "The flight you chose: the wind moved it {distance} left.",
      "right": "The flight you chose: the wind moved it {distance} right.",
      "helped": "{detail, select, low {Low flight under the wind: pattern {percent}% tighter.} other {The flight you chose: pattern {percent}% tighter.}}",
      "hurt": "{detail, select, high {High flight in the wind: pattern {percent}% wider.} other {The flight you chose: pattern {percent}% wider.}}"
    },
    "power": {
      "short": "{detail, select, easy {Your easy swing took {distance} off it.} smooth {Your smooth swing took {distance} off it.} other {Short by {distance}.}}",
      "long": "{detail, select, hard {Your hard swing added {distance}.} all_out {Going all out added {distance}.} other {Long by {distance}.}}",
      "helped": "{detail, select, easy {Your easy swing kept it straight.} smooth {Your smooth swing kept it straight.} other {{unit, select, points {{points, plural, one {# point} other {# points}} more chance than usual.} other {Pattern {percent}% tighter than usual.}}}}",
      "hurt": "{unit, select, points {{detail, select, hard {Your hard swing made a miss like this {points, plural, one {# point} other {# points}} more likely.} all_out {Going all out made a miss like this {points, plural, one {# point} other {# points}} more likely.} other {{points, plural, one {# point} other {# points}} less chance than usual.}}} other {{detail, select, hard {Your hard swing: pattern {percent}% wider.} all_out {Going all out: pattern {percent}% wider.} other {Pattern {percent}% wider than usual.}}}}"
    },
    "grip_down": {
      "short": "Gripping down took {distance} off it.",
      "helped": "Gripping down: pattern {percent}% tighter."
    },
    "spin": {
      "short": "Check spin: it stopped {distance} sooner.",
      "long": "Release: it ran on {distance} further."
    },
    "tee_height": {
      "short": "A low tee took {distance} off it.",
      "long": "A high tee added {distance}.",
      "helped": "A low tee: pattern {percent}% tighter.",
      "hurt": "A high tee: pattern {percent}% wider."
    },
    "routine": {
      "helped": "{unit, select, points {Your full routine: {points, plural, one {# point} other {# points}} more chance to hole it.} other {Your full routine: pattern {percent}% tighter.}}",
      "hurt": "{unit, select, points {A quick routine: {points, plural, one {# point} other {# points}} off your chance to hole it.} other {A quick routine: pattern {percent}% wider.}}"
    },
    "breathing": {
      "helped": "{unit, select, points {Breathing: {points, plural, one {# point} other {# points}} more chance to hole it.} other {Breathing: pattern {percent}% tighter.}}"
    },
    "swing_thought": {
      "helped": "{unit, select, points {{optionName}: {points, plural, one {# point} other {# points}} more chance to hole it.} other {{optionName}: pattern {percent}% tighter.}}",
      "hurt": "{optionName}: pattern {percent}% wider."
    },
    "extra_care": {
      "helped": "{unit, select, points {Extra care: {points, plural, one {# point} other {# points}} more chance to hole it.} other {Extra care: pattern {percent}% tighter.}}"
    },
    "technique": {
      "short": "{optionName}: it stopped {distance} short.",
      "long": "{optionName}: it ran {distance} past.",
      "left": "{optionName}: it finished {distance} left.",
      "right": "{optionName}: it finished {distance} right.",
      "helped": "{optionName}: pattern {percent}% tighter.",
      "hurt": "{unit, select, points {{optionName}: a miss like this was {points, plural, one {# point} other {# points}} more likely.} other {{optionName}: pattern {percent}% wider.}}"
    },
    "putt_line": {
      "helped": "Your line matched the break: {points, plural, one {# point} other {# points}} more chance.",
      "hurt": "{than, select, more {It broke more than you allowed for: {points, plural, one {# point} other {# points}} off your chance.} other {It broke less than you allowed for: {points, plural, one {# point} other {# points}} off your chance.}}"
    },
    "putt_pace": {
      "helped": "The pace you chose: {points, plural, one {# point} other {# points}} more chance to hole it.",
      "hurt": "The pace you chose: {points, plural, one {# point} other {# points}} off your chance to hole it."
    },
    "putt_intent": {
      "helped": "Going for it: {points, plural, one {# point} other {# points}} more chance to hole it.",
      "hurt": "Playing to get it close: {points, plural, one {# point} other {# points}} off your chance to hole it."
    },
    "caddie_jobs": {
      "long": "Grooves not cleaned: it ran on {distance} further.",
      "helped": "Your caddie kept the grips dry: pattern {percent}% tighter.",
      "hurt": "Wet grips: pattern {percent}% wider."
    },
    "caddie_calm": {
      "helped": "{unit, select, points {Your caddie kept you calm: {points, plural, one {# point} other {# points}} more chance to hole it.} other {Your caddie kept you calm: pattern {percent}% tighter.}}"
    },
    "moment_*": {
      "helped": "{optionName}: pattern {percent}% tighter.",
      "hurt": "{optionName}: pattern {percent}% wider."
    },
    "fallback": {
      "short": "Short by {distance}.",
      "long": "Long by {distance}.",
      "left": "Left by {distance}.",
      "right": "Right by {distance}.",
      "helped": "{unit, select, points {{points, plural, one {# point} other {# points}} more chance than usual.} other {Pattern {percent}% tighter than usual.}}",
      "hurt": "{unit, select, points {{points, plural, one {# point} other {# points}} less chance than usual.} other {Pattern {percent}% wider than usual.}}",
      "good": "A good swing.",
      "poor": "The swing itself."
    }
  },
  "$banks": [
    {
      "$note": "21 AI-240; 25 §5: the reason line (TON-081) is a line of receipt.line with slots typed 'resolved'.",
      "keys": ["reason.**"],
      "bank_id": "receipt.line",
      "context": "reason.<factor>.<direction>",
      "in_round": true,
      "slots": {
        "kind": "resolved",
        "unit": "resolved",
        "than": "resolved",
        "detail": "resolved",
        "size": "resolved",
        "distance": "resolved",
        "percent": "resolved",
        "points": "resolved",
        "inTen": "resolved",
        "oneIn": "resolved",
        "optionName": "plain"
      }
    },
    {
      "keys": ["slot.*"],
      "bank_id": "receipt.line",
      "context": "slot.<form>",
      "in_round": true,
      "slots": { "n": "resolved" }
    }
  ]
}
